import { render, staticRenderFns } from "./top-users-table.vue?vue&type=template&id=37518695&scoped=true"
import script from "./top-users-table.vue?vue&type=script&lang=ts"
export * from "./top-users-table.vue?vue&type=script&lang=ts"
import style0 from "./top-users-table.vue?vue&type=style&index=0&id=37518695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37518695",
  null
  
)

export default component.exports